import { render, staticRenderFns } from "./button.vue?vue&type=template&id=87b83aea"
import script from "./button.ts?vue&type=script&lang=js&external"
export * from "./button.ts?vue&type=script&lang=js&external"
import style0 from "./button.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports